<header class="app-header">
  <div class="header-content">
    <div class="logo" (click)="goHome()">
      <img class="logo-mark" src="assets/images/temenos-t-logo.png" [alt]="'FEATURES.HEADER.LOGO_ALT' | transloco">
      <span class="logo-text">{{ 'FEATURES.HEADER.BRAND' | transloco }} <span class="logo-divider">|</span> <span class="logo-suffix">{{ 'FEATURES.HEADER.BRAND_SUFFIX' | transloco }}</span></span>
    </div>

    <div class="header-actions">
      <button type="button" class="btn-help" (click)="openFaq()">
        <svg class="help-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26A2 2 0 1 0 10 9H8a4 4 0 1 1 7.07 2.25z"/>
        </svg>
        {{ 'FEATURES.HEADER.NEED_HELP' | transloco }}
      </button>

      <div class="user-menu" tabindex="0">
        <span class="avatar">{{ initials }}</span>
        <span class="user-name">{{ fullName }}</span>
        <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
        </svg>

        <div class="user-dropdown">
          <div class="user-details">
            <div class="dropdown-name">{{ fullName }}</div>
            <div class="dropdown-email">{{ email }}</div>
          </div>
          <div class="dropdown-divider"></div>
          <div *ngIf="roleKey" class="dropdown-role">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 9c2.7 0 5.8 1.29 6 2v1H6v-.99c.2-.72 3.3-2.01 6-2.01M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/>
            </svg>
            {{ roleKey | transloco }}
          </div>
          <div *ngIf="roleKey" class="dropdown-divider"></div>
          <button type="button" class="dropdown-item sign-out" (click)="logout()">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            {{ 'FEATURES.HEADER.SIGN_OUT' | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
